import { isEmpty } from "lodash";
import { parseNumToFixed } from "../utils/common";

const initialState = {
    id: null,
    goods: [],
    aggData: null,
    removedGoods: [],
    phone: null,
    area: null,
    street: null,
    house: null,
    entrance: null,
    floor: null,
    room: null,
    internalComment: null,    
    point: null,
    zones: null,
    zone: null,
    city: null,
    goodsPrice: 0,
    salePrice: 0,
    sale: null,
    totalPrice: 0,
    unit: null,
    deliveryMethod: 'own',
    deliveryPrice: 0,
    deliveryArticle: null,
    payment: null,
    changeCash: null,
    source: 'crm',
    isAggPrice: false, 
    isSite: false,
    paymentData: null,
    paymentId: null,
    user: null,
    userName: null,
    promocode: null,
    bonusCount: null,
    tags: [],
    isConsumption: false,
    workingShiftId: null,
    status: null,
    changeStatusLog: null,
};

export default function neworders(state = initialState, action) {
  switch(action.type) {
    case 'ADD_POSITION_NEW_ORDER': {
        const good = action.good
        if ([action.setting.pizza, action.setting.wok].includes(action.good.category.id))
        {
            const dataGood = { 
                id: good.id,
                isMod: good.isMod,
                article: good.article,
                name: good.name,
                weight: good.weight,
                count: 1,
                addCount: 1,
                price: good.price ? good.price : 0,
                modifications: good.modifications ? good.modifications : null,
                oldPrice: good.oldPrice ? good.oldPrice : 0,
                category: good.category.id,
                defaultPrice: good.defaultPrice ? good.defaultPrice : null,
                defaultOldPrice: good.defaultOldPrice ? good.defaultOldPrice : null,
                index: state.goods.length > 0 ? state.goods[state.goods.length - 1].index + 1 : 1,
                description: good.description ? good.description : null,
                kcal: good.kcal || null,
                carbs: good.carbs || null,
                proteins: good.proteins || null,
                fats: good.fats || null,
                equipment: !isEmpty(good.equipment) ? good.equipment : null,
            }
            return {
                ...state,
                goods: [...state.goods, dataGood],
            };
        }

        if(action.good.category.id === action.setting.mainWok)
        {
            const dataGood = { 
                id: good.id, 
                isMod: good.isMod ? good.isMod : false,
                article: good.article,
                count: 1, 
                addCount: 1,
                isWok: good.isWok,
                category: good.category.id,
                wokData:{
                    id: good.id + (state.goods.length > 0 ? state.goods[state.goods.length - 1].index + 1 : 1),
                    main: {
                        id: good.id, 
                        article: good.article, 
                        title: good.name, 
                        price: good.price, 
                        oldPrice: good.oldPrice,                        
                    },
                    meat: {},
                    topping: {},
                    souce: {},
                    price: good.price ? good.price : 0,
                    oldPrice: good.oldPrice ? good.oldPrice : 0,
                },                 
                index: state.goods.length > 0 ? state.goods[state.goods.length - 1].index + 1 : 1
            }
            return {
                ...state,
                goods: [...state.goods, dataGood],
            };
        }

        if(state.goods.find((el) => el.id === action.good.id && !el.isPromo))
        {
            const updatedGood = state.goods.map(item =>
                (item.id === action.good.id && !item.isPromo) ? { ...item, count: parseInt(item.count || 1) + 1, addCount: (item.addCount || 0) + 1 } : item
            );
            return {
                ...state,
                goods: updatedGood,
            };
        }
        else
        {
            const dataGood = { 
                id: good.id,
                isMod: good.isMod ? good.isMod : false,
                article: good.article,
                count: 1,
                addCount: 1,
                isWok: false,
                wokData: null,
                name: good.name,
                weight: good.weight,
                price: good.price ? good.price : 0,
                oldPrice: good.oldPrice ? good.oldPrice : 0,
                category: good.category.id,
                description: good.description ? good.description : null,
                index: state.goods.length > 0 ? state.goods[state.goods.length - 1].index + 1 : 1,
                kcal: good.kcal || null,
                carbs: good.carbs || null,
                proteins: good.proteins || null,
                fats: good.fats || null,
                equipment: !isEmpty(good.equipment) ? good.equipment : null,
            }
            return {
                ...state,
                goods: [...state.goods, dataGood],
            };
        }
    }

    case 'PLUS_COUNT_POSITION_NEW_ORDER': {
        const updatedGoods = state.goods.map(item =>
            item.index === action.index ? { ...item, count: parseInt(item.count || 1) + 1, addCount: (item.addCount || 0) + 1 } : item
        );
        return {
            ...state,
            goods: updatedGoods,
        };
    }

    case 'MINUS_COUNT_POSITION_NEW_ORDER': {
        const updatedGoods = state.goods.map(item =>
            item.index === action.index ? { ...item, count: parseInt(item.count || 1) - 1, addCount: (item.addCount || 0) - 1 } : item
        );
        return {
            ...state,
            goods: updatedGoods,
        };
    }

    case 'DELETE_POSITION_NEW_ORDER': {
        return {
            ...state,
            goods: state.goods.filter((item) => item.index !== action.index),
            removedGoods: [...state.removedGoods, state.goods.find((item) => item.index === action.index)]
        };
    }

    case 'CHANGE_COUNT_POSITION_NEW_ORDER': {
        const updatedGoods = state.goods.map(item =>
            item.index === action.index ? { ...item, addCount: parseInt(item.addCount || 0) + (parseInt(action.value) - parseInt(item.count)), count: action.value } : item
        );

        return {
            ...state,
            goods: updatedGoods,
        };
    }

    case 'ADD_ADDITIVES_NEW_ORDER': {
        const field = action.field;
        const getData = () => {
            if (field === 'souce') return ({
                id: action.good.id,
                title: action.good.name,
                price: action.good.price,
                oldPrice: action.good.oldPrice
            });

            return ({
                data: {
                    id: action.good.id,
                    title: action.good.name,
                    price: action.good.price,
                    oldPrice: action.good.oldPrice
                }
            });
        }

        const updatedGoods = state.goods.map(item =>
            item.index === action.index
            ? 
                !item.wokData[field][action.good.id]
                ?
                {
                    ...item,
                    wokData: {
                        ...item.wokData,
                        [field]: {
                            ...item.wokData[field],
                            [action.good.id]: {
                                count: 1,
                                addCount: 1,
                                article: action.good.article,
                                ...getData()
                            }                
                        },
        
                    }
                }
                :
                {
                    ...item,
                    wokData: {
                        ...item.wokData,
                        [field]: {
                            ...item.wokData[field],
                            [action.good.id]: {
                                ...item.wokData[field][action.good.id],
                                count: parseInt(item.wokData[field][action.good.id].count) + 1,
                                addCount: parseInt(item.wokData[field][action.good.id].addCount || 0) + 1
                            }
                        },     
                    }
                }
            : 
            item
        );

        return {
            ...state,
            goods: updatedGoods,
        };
    }
    
    case 'PLUS_COUNT_ADDITIVES_NEW_ORDER': {
        const field = action.subtype;
        switch(field) {
            case 'main': return state
            default: {
                const updatedGoods = state.goods.map(item =>
                    item.index === action.index 
                    ? 
                    {
                        ...item,
                        wokData: {
                            ...item.wokData,
                            [field]: {
                                ...item.wokData[field],
                                [action.idAdditives]: {
                                    ...item.wokData[field][action.idAdditives],
                                    count: parseInt(item.wokData[field][action.idAdditives].count) + 1,
                                    addCount: parseInt(item.wokData[field][action.idAdditives].addCount || 0) + 1
                                }
                            }
                        }
                    } 
                    : 
                    item
                );

                return {
                    ...state,
                    goods: updatedGoods,
                };
            }
        }        
    }

    case 'MINUS_COUNT_ADDITIVES_NEW_ORDER': {
        const field = action.subtype;
        switch(field) {
            case 'main': return state;

            default: {
                const updatedGoods = state.goods.map(item =>
                    item.index === action.index 
                    ? 
                    { 
                        ...item,
                        wokData: {
                            ...item.wokData,
                            [field]: {
                                ...item.wokData[field],
                                [action.idAdditives]: {
                                    ...item.wokData[field][action.idAdditives],
                                    count: parseInt(item.wokData[field][action.idAdditives].count) - 1,
                                    addCount: parseInt(item.wokData[field][action.idAdditives].addCount || 0) - 1
                                }
                            }
                        }
                    } 
                    : 
                    item
                );
                return {
                    ...state,
                    goods: updatedGoods,
                };
            }
        }
    }

    case 'DELETE_ADDITIVES_NEW_ORDER': {
        const field = action.subtype;
        const updatedGoods = state.goods.map(item =>
            item.index === action.index 
            ? 
            { 
                ...item,
                wokData: {
                    ...item.wokData,
                    [field]: Object.fromEntries(
                        Object.entries(item.wokData[field]).filter(([key, el]) => {
                            const id = el.data ? el.data.id || el.id : el.id;
                            if (id !== action.idAdditives) return true;
                            return false;
                        })
                    ),
                }
            } 
            : 
            item
        );
        return {
            ...state,
            goods: updatedGoods,
        };
    }

    case 'CHANGE_COUNT_ADDITIVES_NEW_ORDER': {
        const field = action.subtype;
        switch(field) {
            case 'main': {
                const updatedGoods = state.goods.map(item =>
                    item.index === action.index 
                    ? 
                    { 
                        ...item,
                        addCount: parseInt(item.addCount || 0) + (parseInt(action.value) - parseInt(item.count)),
                        count: parseInt(action.value),
                    } 
                    : 
                    item
                );
                return {
                    ...state,
                    goods: updatedGoods,
                };
            }

            default: {
                const updatedGoods = state.goods.map(item =>
                    item.index === action.index 
                    ? 
                    { 
                        ...item,
                        wokData: {
                            ...item.wokData,
                            [field]: {
                                ...item.wokData[field],
                                [action.idAdditives]: {
                                    ...item.wokData[field][action.idAdditives],
                                    count: parseInt(action.value),
                                    addCount: parseInt(item.wokData[field][action.idAdditives].addCount || 0) + (parseInt(action.value) - parseInt(item.wokData[field][action.idAdditives].count)),
                                }
                            }
                        }
                    } 
                    : 
                    item
                );
                return {
                    ...state,
                    goods: updatedGoods,
                };
            }
        }
    }

    case 'CALCULATE_WOK_PRICE': {
        const getWokDataPrice = (data, field) => {
            if (!field) return;
            return Object.values(data).reduce((acc, item) => {
                let price = item.data ? item.data[field] ? item.data[field] : item.data.price : null;
                if (!price) price = item[field] ? item[field] : item.price || 0;
                if (!price) return acc;
                acc += price * item.count;
                return acc;
            }, 0);
        }

        const getWokPrice = (wokData, field, count) => {
            if (!wokData || !field) return;
            const mainPrice = wokData.main[field] ? wokData.main[field] : wokData.main.price || 0;
            const sum = Object.entries(wokData).reduce((acc, [key, data]) => {
                if (key === 'main') return acc;
                acc += getWokDataPrice(data, field);
                return acc;
            }, 0);
            return mainPrice + sum;
        }

        const updatedGoods = state.goods.map((item) => 
        item.index === action.index
        ?
            item.wokData
            ?
            { 
                ...item,
                wokData: {
                    ...item.wokData,
                    id: item.wokData.id,
                    price: getWokPrice(item.wokData, 'price', item.count),
                    oldPrice: getWokPrice(item.wokData, 'oldPrice', item.count),         
                }
            } 
            :
            item
        :
        item
    )

    return {
        ...state,
        goods: updatedGoods,
    };
    }

    case 'SET_SALE_PERSENT_NEW_ORDER': {
        if(action.value && action.value !== state.sale)
            return {
                ...state,
                promocode: null,
                promotion: null,
                sale: {
                    code: 'handler',
                    name: '',
                    data: {
                        name: '',
                        value: action.value,
                        persent: 1,
                        type: 'order',
                        goods: null,
                        category: null,
                    },
                },
            };

        return {
            ...state,
            sale: null,
            salePrice: 0
        };
    }

    case 'SET_SALE_SUM_NEW_ORDER': {
        if (!action.value) 
            return {
                ...state,
                sale: null,
                salePrice: 0
            };
        return {
            ...state,
            promocode: null,
            promotion: null,
            sale: {
                code: 'handler',
                name: '',
                data: {
                    name: '',
                    value: parseFloat(action.value) < parseFloat(state.goodsPrice) ? action.value : state.goodsPrice - 1,
                    persent: 0,
                    type: 'order',
                    goods: null,
                    category: null,
                },
            },
        };
    }

    case 'CALCULATION_TOTALPRICE_NEW_ORDER': {
        let salePrice = state.salePrice;

        const getGoodsPrice = () => {
            return (state.goods.reduce((Sum, item) => 
            !item.wokData
            ?
                Sum + item.price * parseInt(item.count || 1)
            :
                Sum + parseFloat(item.wokData.price) * parseInt(item.count || 1), 0)).toFixed(2);
            };

        if(state.sale && state.sale.data) {
            const sale = state.sale.data;
            salePrice = (sale.type === 'order')
            ? sale.persent
                ?
                +Math.round((getGoodsPrice() * (+sale.value / 100)))
                :
                +sale.value
            : 0;

            if (sale.type === 'goods' && sale.goods) {
                salePrice = state.goods.reduce((acc, item) => {
                    return acc += sale.goods[item.id]
                    ? sale.goods[item.id].persent 
                        ?
                            +Math.round(item.price * item.count * (sale.goods[item.id].sale / 100))
                        :
                            +(sale.goods[item.id].sale * item.count)
                    : 0
                }, 0);
            }

            if (sale.type === 'category' && sale.category) {
                salePrice = state.goods.reduce((acc, item) => {
                    const categoryId = item.category.id || item.category;
                    return acc += categoryId === sale.category.value
                    ? sale.persent 
                        ?
                            +Math.round(item.price * item.count * (sale.value / 100))
                        :
                            +sale.value * item.count
                    : 0
                }, 0);
            }
        }

        const goodsPrice = getGoodsPrice();

        const getTotalPrice = () => {
            let total = 0;
            if (goodsPrice && goodsPrice > 0) total += parseNumToFixed(goodsPrice);
            if (salePrice && salePrice > 0) total -= parseNumToFixed(salePrice);
            if (state.bonusCount && state.bonusCount > 0) total -= parseNumToFixed(state.bonusCount);
            if (state.deliveryPrice && state.deliveryPrice > 0) total += parseNumToFixed(state.deliveryPrice);
            return (total && total > 0) ? parseNumToFixed(total) : 1;
        }
        
        return { 
            ...state,
            goodsPrice: goodsPrice,
            totalPrice: getTotalPrice(),
            salePrice: salePrice ? salePrice > goodsPrice ? parseNumToFixed(goodsPrice - 1) : parseNumToFixed(salePrice) : 0,
        };
    }

    case 'CHANGE_POINT_NEW_ORDER': {
        return { 
            ...state,
            point: action.point,
            city: action.city,
            }
    }

    case 'ADD_DELIVERY_PRICED_NEW_ORDER': {
        return {
            ...state,
            deliveryArticle: action.article,
            deliveryPrice: action.price
        }
    }

    case 'SET_ZONES_NEW_ORDER': {
        return { 
            ...state,
            zones: action.value
            }
    }

    case 'CHANGE_DELIVERY_METHOD_NEW_ORDER': {
        return { 
            ...state,
            deliveryMethod: action.value
            }
    }

    case 'CHANGE_INFORMATION_NEW_ORDER': {
        return { 
            ...state,
            [action.subtype]: action.value
            }          
    }

    case 'CHANGE_AGG_PRICE_NEW_ORDER': {
        const checkPriceGoods = (item) => {
            const field = action.value ? 'oldPrice' : 'price';
            const id = typeof item.id === 'number' ? item.id : item.id.split('_')[0];
            const modId = typeof item.id === 'number' ? null : item.id.split('_')[1];
            
            const entityGood = action.goodsChek.find((el) => el.id === parseInt(id));
            if (isEmpty(entityGood)) return item[field] ? +item[field] : +item.price || 0;
            
            const getRegionPrice = (item, field) => {
                const goodPrice = item[field] ? +item[field] : +item.price || 0;
                if (isEmpty(item.regionprices)) return goodPrice;
                let cityId;

                if (!isEmpty(state.point) && !isEmpty(state.point.city)) {
                    if (typeof state.point.city === 'object') cityId = +state.point.city.id;
                    if (typeof state.point.city === 'number') cityId = +state.point.city;
                } else if (!isEmpty(state.city)) {
                    if (typeof state.city === 'object') cityId = +state.city.id;
                    if (typeof state.city === 'number') cityId = +state.city;
                }

                const entityRegionPrice = item.regionprices.find((regionprice) => regionprice.cities.some((item) => parseInt(item.id) === cityId) && regionprice.active)
                if (isEmpty(entityRegionPrice)) return goodPrice;

                const valueRegionPrice = entityRegionPrice[field] ? +entityRegionPrice[field] : entityRegionPrice.price || 0;
                if (valueRegionPrice == null) return goodPrice;

                switch(entityRegionPrice.condition) {
                    case('equal'): {
                        if (valueRegionPrice) return valueRegionPrice;
                        return goodPrice;
                    }
                    case('plus'): {
                        if (entityRegionPrice.persent) return +Math.round((goodPrice + (goodPrice / 100 * valueRegionPrice)));
                        return +Math.round((goodPrice + valueRegionPrice).toFixed(0));
                    }
                    case('minus'): {
                        if (entityRegionPrice.persent) return +Math.round((goodPrice - (goodPrice / 100 * valueRegionPrice)).toFixed(0));
                        return +Math.round((goodPrice - valueRegionPrice).toFixed(0));
                    }
                    case('multiply'): {
                        return +Math.round((goodPrice * valueRegionPrice).toFixed(0));
                    }                
                    default: {
                        return goodPrice;
                    }
                }
            }

            const getModPrice = (item, modId, regionPrice, field) => {
                const goodPrice = regionPrice != null ? regionPrice : item[field] ? +item[field] : +item.price || 0;
                if (!modId || isEmpty(item.modifications)) return goodPrice;

                const entitiModification = item.modifications.find((mod) => mod.id === parseInt(modId));
                if (isEmpty(entitiModification) || entitiModification.default) return goodPrice;
                
                const modPrice = entitiModification[field] ? +entitiModification[field] : +entitiModification.price || 0;
                if (modPrice == null) return goodPrice;

                switch(entitiModification.condition) {
                    case('equal'): {
                        if (modPrice) return modPrice;
                        return goodPrice;
                    }
                    case('plus'): {
                        if (entitiModification.persent) return +Math.round((goodPrice + (goodPrice / 100 * modPrice)));
                        return +Math.round((goodPrice + modPrice).toFixed(0));
                    }
                    case('minus'): {
                        if (entitiModification.persent) return +Math.round((goodPrice - (goodPrice / 100 * modPrice)).toFixed(0));
                        return +Math.round((goodPrice - modPrice).toFixed(0));
                    }
                    case('multiply'): {
                        return +Math.round((goodPrice * modPrice).toFixed(0));
                    }                
                    default: {
                        return goodPrice;
                    }
                }
            }

            const regionPrice = getRegionPrice(entityGood, field);
            const modPrice = getModPrice(entityGood, modId, regionPrice, field);
            return modPrice;
        }

        let goods = state.goods.map((item) => ({
            ...item,
            price: checkPriceGoods(item),
        }));

        return { 
            ...state,
            isAggPrice: action.value,
            goods: goods
            }
    }

    case 'CHANGE_PAYMENT_NEW_ORDER': {
        if(action.value !== state.payment)
        return {
            ...state,
            payment: action.value,
            changeCash: null
            }

        return {
            ...state,
            payment: null,
            changeCash: null 
            }
    }

    case 'ADD_TAG_NEW_ORDER': {
        const tagExists = state.tags ? state.tags.some(el => el.id === action.tag.id) : false;
        
        if (!tagExists) {
          return {
            ...state,
            tags: [...state.tags, action.tag]
          };
        } else {
          return {
            ...state,
            tags: state.tags.filter(el => el.id !== action.tag.id)
          };
        }
      }

    case 'CHANGE_CHANGECASH_NEW_ORDER': {
        if(action.data.value !== state.changeCash)
        return {
            ...state,
            changeCash: action.data.value,
            changeSum: action.data.sum,            
            }

        return {
            ...state,
            changeCash: null,
            changeSum: null, 
            }
    }

    case 'OPEN_EDIT_ORDER': {
        const order = action.order;
        let goodsWithIndex = []

        const goodData = (good) => {
            const entityGood = action.goodsChek.find((el) => el.id === parseInt(good.id));
            if (!entityGood) return good;
            return {
                ...good,
                description: good.description || entityGood.description || null,
                kcal: good.kcal || entityGood.kcal || null,
                proteins: good.proteins || entityGood.proteins || null,
                fats: good.fats || entityGood.fats || null,
                carbs: good.carbs || entityGood.carbs || null,
                equipment: !isEmpty(good.equipment) ? good.equipment : !isEmpty(entityGood.equipment) ? entityGood.equipment : null,
            }
        }

        if(order.isAggPrice) {
            goodsWithIndex = order.goods.map((good, index) => ({
                ...goodData(good),
                oldPrice: good.price,
                index
            }))
        } else {
            goodsWithIndex = order.goods.map((good, index) => ({
                ...goodData(good),
                index 
            }));
        }

        const sourceCheck = (source, isSite) => {
            if (source) return source;
            if (!source && isSite) return 'site';
            if (!source && !isSite) return 'app';
            return 'crm';
        }

        return {
            ...state,
            ...order,
            goods: goodsWithIndex,
            point: action.point,
            goodsPrice: parseNumToFixed(order.goodsPrice),
            salePrice: parseNumToFixed(order.salePrice),
            totalPrice: parseNumToFixed(order.totalPrice),
            source: sourceCheck(order.source, order.isSite),
            tags: (order.tags && order.tags.length > 0) ? order.tags : [],
        }
    }

    case 'OPEN_COPY_ORDER': {
        const order = action.order
        let goodsWithIndex = []
        
        const goodData = (good) => {
            const entityGood = action.goodsChek.find((el) => el.id === parseInt(good.id));
            if (!entityGood) return good;
            return {
                ...good,
                description: good.description || entityGood.description || null,
                kcal: good.kcal || entityGood.kcal || null,
                proteins: good.proteins || entityGood.proteins || null,
                fats: good.fats || entityGood.fats || null,
                carbs: good.carbs || entityGood.carbs || null,
                price: entityGood.price,
                equipment: !isEmpty(good.equipment) ? good.equipment : !isEmpty(entityGood.equipment) ? entityGood.equipment : null,
            }
        }
        
        goodsWithIndex = order.goods
            .filter((good) => !good.isPromo)
            .map((good, index) => ({
                ...goodData(good),
                index 
        }));
    
        if (action.isCopyAll) {
            return {
                ...state,
                internalComment: order.internalComment ? order.internalComment : order.comment,
                deliveryMethod: order.deliveryMethod,
                entrance: order.entrance,
                floor: order.floor,
                house: order.house,
                city: order.city,
                point: action.point,
                room: order.room,
                street: order.street,
                goods: goodsWithIndex,
            }
        } else {
            return {
                ...state,
                internalComment: order.internalComment ? order.internalComment : order.comment,
                deliveryMethod: order.deliveryMethod,
                entrance: order.entrance,
                floor: order.floor,
                house: order.house,
                city: order.city,
                point: action.point,
                room: order.room,
                street: order.street,
            }
        }
    }

    case 'CLEAR_NEW_ORDER': {
        return initialState
    }

    case 'ADD_GOOD_PROMO': {
        const updatedGoods = [...state.goods];
        (action.goods || []).forEach((good) => {
            if (!good) return;
            const promoGood = {
                ...(good || {}),
                index: updatedGoods.length > 0 ? updatedGoods[updatedGoods.length - 1].index + 1 : 1,
            }
            updatedGoods.push(promoGood);
        });
        return {
            ...state,
            goods: updatedGoods,
        };
    }

    case 'SET_PROMO': {
        const { id, name, value, persent, type, goods, category } = action.promo;
        return {
            ...state,
            isChangePromo: true,
            promotion: id,
            promocode: null,
            errorPromocode: null,
            promocodeName: null,
            promoData: action.promo,
            sale: {
                code: 'promocode',
                name: 'Акция: ' + name,
                data: {
                    name: 'Акция: ' + name,
                    value,
                    persent,
                    type,
                    goods,
                    category,
                },
            },
        };
    }

    case 'SET_PROMOCODE_ORDER': {
        const { id, name, value, persent, type, goods, category } = action.promocode;
        return {
            ...state,
            promocode: id,
            isChangePromo: true,
            promotion: null,
            promocodeName: null,
            promoData: action.promocode,
            sale: {
                code: 'promocode',
                name: 'Скидка по промокоду ' + name,
                data: {
                    name: 'Скидка по промокоду ' + name,
                    value,
                    persent,
                    type,
                    goods,
                    category,
                },
            },
        }
    }

    case 'CLEAR_PROMO': {
        const updatedGoods = state.goods.filter(item => !item.isPromo);
        return {
            ...state,
            promotion: null,
            promocode: null,
            promocodeName: null,
            sale: null,
            salePrice: 0,
            errorPromocode: null,
            goods: updatedGoods
        };
    }

    case 'SET_ERROR_PROMOCODE': {
        return  {
            ...state,
            errorPromocode: action.error
        }
    }

    default: return state;
  }
}

